import { render, staticRenderFns } from "./BookingCustomFieldsSection.vue?vue&type=template&id=4c170528&scoped=true&"
import script from "./BookingCustomFieldsSection.vue?vue&type=script&lang=js&"
export * from "./BookingCustomFieldsSection.vue?vue&type=script&lang=js&"
import style0 from "./BookingCustomFieldsSection.vue?vue&type=style&index=0&id=4c170528&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c170528",
  null
  
)

export default component.exports